/* Community Feed - signed-in actions (Part B).
   Talks to the worker through Shopify's App Proxy at /apps/community/*.
   Shopify stamps every request with the signed-in customer, so no tokens
   ever touch the browser. */
(function () {
  var BASE = '/apps/community';
  if (!document.querySelector('.community-feed')) return;

  var me = null;

  function pendingNoteText() {
    var root = document.querySelector('.community-feed');
    return (root && root.getAttribute('data-pending-note')) || 'Pending approval.';
  }

  // The author's not-yet-approved posts/comments, remembered per browser so
  // they survive reloads. Cleared automatically once the item shows up in the
  // synced feed (meaning an admin approved it). Entries expire after 7 days.
  var PENDING_KEY = 'ix1-community-pending';
  function pendingLoad() {
    try { return JSON.parse(localStorage.getItem(PENDING_KEY) || '[]'); } catch (e) { return []; }
  }
  function pendingSave(list) {
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(list)); } catch (e) { /* fine */ }
  }
  function pendingAdd(entry) {
    var list = pendingLoad();
    entry.ts = Date.now();
    list.push(entry);
    pendingSave(list);
  }

  function pendingBadge() {
    var b = document.createElement('span');
    b.className = 'community-card__pending-badge';
    b.textContent = 'Pending approval';
    return b;
  }

  function pendingNoteEl() {
    var n = document.createElement('p');
    n.className = 'community-card__pending-note';
    n.textContent = pendingNoteText();
    return n;
  }

  function restorePending() {
    if (!me || !me.logged_in) return;
    var list = pendingLoad();
    if (!list.length) return;
    var keep = [];
    var cutoff = Date.now() - 96 * 3600 * 1000; // 4 days: covers weekends before review
    list.forEach(function (entry) {
      if (entry.ts < cutoff) return; // expired (approved long ago or rejected)
      if (me.author_key && entry.author_key && entry.author_key !== me.author_key) { keep.push(entry); return; }
      if (entry.kind === 'post') {
        var syncedPost = document.querySelector('.community-card[data-post-id="' + entry.data.id + '"]:not([data-pending])');
        if (syncedPost) return; // approved and synced: badge no longer needed
        keep.push(entry);
        // Only show the pending card where the real post would appear:
        // a tagged product's page, its own category page, or the community page.
        var form = document.querySelector('[data-composer]');
        var pageTopic = form ? form.getAttribute('data-topic-id') : '';
        var pageSpace = form ? form.getAttribute('data-space-id') : '';
        var belongs;
        if (pageTopic) {
          belongs = (entry.data.topic_ids || []).map(String).indexOf(String(pageTopic)) !== -1;
        } else if (pageSpace) {
          belongs = String(entry.data.space_id || '') === String(pageSpace);
        } else {
          belongs = true; // community page shows everything
        }
        if (!belongs) return;
        var listEl = document.querySelector('[data-feed-list]');
        if (listEl && !document.querySelector('[data-pending][data-post-id="' + entry.data.id + '"]')) {
          listEl.insertBefore(renderPost(entry.data, true), listEl.firstChild);
        }
      } else {
        var syncedComment = document.querySelector('[data-comment-id="' + entry.data.id + '"]:not([data-pending])');
        if (syncedComment) return; // approved and synced
        var card = document.querySelector('.community-card[data-post-id="' + entry.post_id + '"]');
        if (card && !document.querySelector('[data-pending][data-comment-id="' + entry.data.id + '"]')) {
          var echo = card.querySelector('[data-echo]');
          if (echo) { echo.hidden = false; echo.appendChild(renderComment(entry.data, true)); }
        }
        keep.push(entry);
      }
    });
    pendingSave(keep);

    // Pending posts remembered on the Shopify account (posted from another
    // device). The worker already dropped expired ones; anything that has
    // synced in, or was rendered from this browser's own memory above, is
    // skipped via the data-post-id check.
    (me.pending_posts || []).forEach(function (p) {
      if (!p || !p.id) return;
      if (document.querySelector('.community-card[data-post-id="' + p.id + '"]')) return;
      var form = document.querySelector('[data-composer]');
      var pageTopic = form ? form.getAttribute('data-topic-id') : '';
      var pageSpace = form ? form.getAttribute('data-space-id') : '';
      var belongs;
      if (pageTopic) {
        belongs = (p.topic_ids || []).map(String).indexOf(String(pageTopic)) !== -1;
      } else if (pageSpace) {
        belongs = String(p.space_id || '') === String(pageSpace);
      } else {
        belongs = true;
      }
      if (!belongs) return;
      var listEl = document.querySelector('[data-feed-list]');
      if (listEl) listEl.insertBefore(renderPost(p, true), listEl.firstChild);
    });
  }

  function isMine(el) {
    if (!me || !me.logged_in) return false;
    var m = el.getAttribute('data-member-id');
    var u = el.getAttribute('data-user-id');
    var k = el.getAttribute('data-author-key');
    return (me.circle_member_id && m && String(me.circle_member_id) === m) ||
           (me.circle_user_id && u && String(me.circle_user_id) === u) ||
           (me.author_key && k && me.author_key === k);
  }

  function apply() {
    var signedIn = !!(me && me.logged_in);
    document.querySelectorAll('[data-comment-form]').forEach(function (f) { f.hidden = !signedIn; });
    document.querySelectorAll('[data-signin]').forEach(function (p) { p.hidden = signedIn; });
    document.querySelectorAll('[data-comment-id]').forEach(function (c) {
      var del = c.querySelector(':scope > .community-card__comment-main > .community-card__comment-head > [data-delete]');
      if (del) del.hidden = !isMine(c);
    });
  }

  fetch(BASE + '/whoami', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (d) { me = d; apply(); restorePending(); })
    .catch(function () { me = null; apply(); });

  function postJSON(path, data) {
    return fetch(BASE + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function avatarSeed(name) { return (name || '').length % 5; }

  function renderComment(c, pending) {
    var wrap = document.createElement('div');
    wrap.className = 'community-card__comment';
    if (pending) wrap.setAttribute('data-pending', '1');
    wrap.setAttribute('data-comment-id', c.id || '');
    wrap.setAttribute('data-member-id', c.member_id || '');
    wrap.setAttribute('data-user-id', c.user_id || '');
    wrap.setAttribute('data-author-key', c.author_key || '');
    var av = document.createElement('span');
    av.className = 'community-card__avatar community-card__avatar--sm community-card__avatar--' + avatarSeed(c.author);
    av.setAttribute('aria-hidden', 'true');
    av.textContent = c.initials || 'IX';
    var main = document.createElement('div');
    main.className = 'community-card__comment-main';
    var head = document.createElement('div');
    head.className = 'community-card__comment-head';
    var who = document.createElement('span');
    who.className = 'community-card__comment-author';
    who.textContent = c.author || 'Community member';
    var when = document.createElement('span');
    when.className = 'community-card__comment-date';
    when.textContent = 'Just now';
    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'community-card__delete';
    del.setAttribute('data-delete', '');
    del.textContent = 'Delete';
    head.appendChild(who); head.appendChild(when);
    if (pending) head.appendChild(pendingBadge());
    head.appendChild(del);
    if (pending) del.hidden = false; // your own pending comment is always deletable
    var body = document.createElement('div');
    body.className = 'community-card__comment-body';
    body.innerHTML = c.body_html; // built and escaped by the worker
    main.appendChild(head); main.appendChild(body);
    if (pending) main.appendChild(pendingNoteEl());
    wrap.appendChild(av); wrap.appendChild(main);
    return wrap;
  }

  function bumpCount(card, delta) {
    var count = card.querySelector('[data-comment-count]');
    if (!count) return;
    var n = (parseInt(count.textContent, 10) || 0) + delta;
    count.textContent = String(n < 0 ? 0 : n);
  }

  // ---- Post a comment ------------------------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-comment-form]');
    if (!form) return;
    e.preventDefault();

    var card = form.closest('.community-card');
    var postId = card.getAttribute('data-post-id');
    var ta = form.querySelector('textarea');
    var nameWrap = form.querySelector('[data-name-wrap]');
    var nameInput = nameWrap.querySelector('input');
    var status = form.querySelector('[data-status]');
    var btn = form.querySelector('button[type="submit"]');
    var body = (ta.value || '').trim();
    if (!body) { status.textContent = 'Write something first.'; ta.focus(); return; }

    btn.disabled = true;
    status.textContent = 'Posting…';

    var chain = Promise.resolve({ ok: true });
    if (!nameWrap.hidden) {
      var name = (nameInput.value || '').trim();
      if (name.length < 2) {
        status.textContent = 'Please add your name.';
        btn.disabled = false; nameInput.focus(); return;
      }
      chain = postJSON('/name', { name: name });
    }

    chain.then(function (n) {
      if (n && n.error) throw new Error(n.error);
      return postJSON('/comments', { post_id: postId, body: body });
    }).then(function (res) {
      if (res.needs_name) {
        nameWrap.hidden = false;
        status.textContent = 'Add your name, then post again.';
        nameInput.focus();
        btn.disabled = false;
        return;
      }
      if (res.error) throw new Error(res.error);

      if (me && res.comment.member_id) me.circle_member_id = res.comment.member_id;
      if (me && res.comment.user_id) me.circle_user_id = res.comment.user_id;

      var echo = card.querySelector('[data-echo]');
      echo.hidden = false;
      echo.appendChild(renderComment(res.comment, true));
      var details = card.querySelector('[data-comments]');
      if (details) details.open = true;
      pendingAdd({ kind: 'comment', post_id: postId, author_key: me && me.author_key, data: res.comment });

      ta.value = '';
      nameWrap.hidden = true;
      status.textContent = 'Submitted for review.';
      setTimeout(function () { status.textContent = ''; }, 3000);
      btn.disabled = false;
    }).catch(function (err) {
      status.textContent = err.message || 'Something went wrong. Please try again.';
      btn.disabled = false;
    });
  });

  // ---- Composer media uploads ----------------------------------------------
  // Files upload as soon as they're picked, through the worker relay.
  // pickedMedia: [{key, file, previewUrl, kind, status: 'uploading'|'done'|'error', signed_id}]
  var pickedMedia = [];
  var MAX_IMAGES = 4, MAX_VIDEOS = 1;
  var MAX_IMAGE_BYTES = 10 * 1024 * 1024, MAX_VIDEO_BYTES = 50 * 1024 * 1024;

  function mediaStatusEl() { return document.querySelector('[data-media-status]'); }

  /** Small data-URL thumbnail drawn in the browser. Returns null when the
   *  format can't be decoded locally (e.g. HEIC on some browsers) - the
   *  upload still works, the tile just shows "Photo" instead. */
  function makeThumb(file) {
    return new Promise(function (resolve) {
      var fallback = setTimeout(function () { resolve(null); }, 4000);
      try {
        createImageBitmap(file).then(function (bmp) {
          clearTimeout(fallback);
          try {
            var scale = Math.min(1, 320 / Math.max(bmp.width, bmp.height));
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(bmp.width * scale));
            canvas.height = Math.max(1, Math.round(bmp.height * scale));
            canvas.getContext('2d').drawImage(bmp, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', 0.75));
          } catch (e) { resolve(null); }
        }).catch(function () { clearTimeout(fallback); resolve(null); });
      } catch (e) { clearTimeout(fallback); resolve(null); }
    });
  }

  function renderMediaList() {
    var list = document.querySelector('[data-media-list]');
    if (!list) return;
    list.innerHTML = '';
    pickedMedia.forEach(function (m) {
      var item = document.createElement('div');
      item.className = 'community-composer__media-item' + (m.status === 'error' ? ' is-error' : '');
      if (m.kind === 'image' && m.previewUrl) {
        var img = document.createElement('img');
        img.src = m.previewUrl;
        img.alt = '';
        item.appendChild(img);
      } else {
        var vid = document.createElement('span');
        vid.className = 'community-composer__media-video';
        vid.textContent = m.kind === 'video' ? 'Video' : 'Photo';
        item.appendChild(vid);
      }
      var state = document.createElement('span');
      state.className = 'community-composer__media-state';
      state.textContent = m.status === 'uploading' ? 'Uploading…' : (m.status === 'error' ? (m.error || 'Failed') : 'Ready');
      item.appendChild(state);
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'community-composer__media-remove';
      x.setAttribute('aria-label', 'Remove');
      x.textContent = '×';
      x.addEventListener('click', function () {
        pickedMedia = pickedMedia.filter(function (o) { return o.key !== m.key; });
        try { URL.revokeObjectURL(m.previewUrl); } catch (e) {}
        renderMediaList();
      });
      item.appendChild(x);
      list.appendChild(item);
    });
  }

  function uploadOne(m) {
    m.status = 'uploading';
    renderMediaList();
    return fetch(BASE + '/uploads?filename=' + encodeURIComponent(m.file.name) + '&content_type=' + encodeURIComponent(m.file.type), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': m.file.type },
      body: m.file
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.needs_name) {
        var nw = document.querySelector('[data-composer] [data-name-wrap]');
        if (nw) nw.hidden = false;
        m.status = 'error'; m.error = 'Add your name below, then re-add this file.';
      } else if (res.error) { m.status = 'error'; m.error = res.error; }
      else {
        m.status = 'done'; m.signed_id = res.signed_id; m.kind = res.kind;
        m.filename = res.filename || m.file.name; m.content_type = res.content_type || m.file.type;
      }
      renderMediaList();
    }).catch(function () {
      m.status = 'error'; m.error = 'Upload failed. Remove and try again.';
      renderMediaList();
    });
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('[data-media-pick]');
    if (!pick) return;
    var input = document.querySelector('[data-media-input]');
    if (input) input.click();
  });

  document.addEventListener('change', function (e) {
    if (!(e.target.matches && e.target.matches('[data-media-input]'))) return;
    var status = mediaStatusEl();
    status.textContent = '';
    Array.prototype.forEach.call(e.target.files, function (file) {
      var isVideo = /^video\//.test(file.type);
      var images = pickedMedia.filter(function (m) { return m.kind === 'image'; }).length;
      var videos = pickedMedia.filter(function (m) { return m.kind === 'video'; }).length;
      if (isVideo && videos >= MAX_VIDEOS) { status.textContent = 'One video per post.'; return; }
      if (!isVideo && images >= MAX_IMAGES) { status.textContent = 'Up to ' + MAX_IMAGES + ' photos per post.'; return; }
      if (isVideo && file.size > MAX_VIDEO_BYTES) { status.textContent = 'Videos can be up to 50 MB.'; return; }
      if (!isVideo && file.size > MAX_IMAGE_BYTES) { status.textContent = 'Photos can be up to 10 MB.'; return; }
      var m = {
        key: Date.now() + '-' + Math.random(),
        file: file,
        kind: isVideo ? 'video' : 'image',
        previewUrl: '',
        status: 'uploading'
      };
      pickedMedia.push(m);
      if (!isVideo) {
        makeThumb(file).then(function (thumb) {
          if (thumb) { m.previewUrl = thumb; renderMediaList(); }
        });
      }
      uploadOne(m);
    });
    e.target.value = '';
  });

  // ---- Composer: share a post (modal) --------------------------------------
  // iOS Safari ignores overflow:hidden on body, so freeze the page in place
  // instead. Remembers the scroll position and puts it back on close.
  var lockedScrollY = 0;
  function lockPageScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('community-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockPageScroll() {
    document.documentElement.classList.remove('community-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }
  function closeComposerModal() {
    var m = document.querySelector('[data-composer-modal]');
    if (m && !m.hidden) {
      m.hidden = true;
      unlockPageScroll();
    }
  }

  function showTopicGroup(spaceId) {
    document.querySelectorAll('[data-topic-group]').forEach(function (g) {
      g.hidden = g.getAttribute('data-topic-group') !== String(spaceId || '');
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-composer-open]');
    if (open) {
      var modal = document.querySelector('[data-composer-modal]');
      if (modal) {
        // Escape any animated/transformed ancestor (Dawn's scroll effects trap
        // position:fixed) by parking the modal directly under <body>.
        if (modal.parentElement !== document.body) document.body.appendChild(modal);
        modal.hidden = false;
        lockPageScroll();
        var form = modal.querySelector('[data-composer]');
        showTopicGroup(form.getAttribute('data-space-id') || (form.querySelector('select[name="space_id"]') || {}).value);
        var panel = modal.querySelector('.community-modal__panel');
        if (panel) panel.scrollTop = 0;
        // Desktop only. Auto-focusing on phones pops the keyboard and makes
        // iOS Safari zoom and scroll the page before the modal has settled.
        var t = modal.querySelector('input[name="title"]');
        if (t && window.matchMedia('(min-width: 768px)').matches) t.focus();
      }
      return;
    }
    var cancel = e.target.closest && e.target.closest('[data-composer-cancel]');
    if (cancel) closeComposerModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeComposerModal();
  });

  // Category choice reveals that category's product checkboxes.
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('select[name="space_id"]')) {
      document.querySelectorAll('[data-topic-group] input[type="checkbox"]').forEach(function (cb) { cb.checked = false; cb.disabled = false; });
      showTopicGroup(e.target.value);
    }
    // Enforce the 5-tag limit: at 5, the unchecked boxes lock.
    if (e.target.matches && e.target.matches('[data-topic-group] input[type="checkbox"]')) {
      var group = e.target.closest('[data-topic-group]');
      var checked = group.querySelectorAll('input:checked').length;
      group.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.disabled = !cb.checked && checked >= 5;
      });
    }
  });

  function renderPost(p, pending) {
    var art = document.createElement('article');
    art.className = 'community-card';
    art.setAttribute('data-post-id', p.id || '');
    if (pending) art.setAttribute('data-pending', '1');
    var head = document.createElement('header');
    head.className = 'community-card__head';
    var av = document.createElement('span');
    av.className = 'community-card__avatar community-card__avatar--' + avatarSeed(p.author);
    av.setAttribute('aria-hidden', 'true');
    av.textContent = p.initials || 'IX';
    var byline = document.createElement('div');
    byline.className = 'community-card__byline';
    var who = document.createElement('span');
    who.className = 'community-card__author';
    who.textContent = p.author || 'Community member';
    var when = document.createElement('time');
    when.className = 'community-card__time';
    when.textContent = 'Just now';
    byline.appendChild(who); byline.appendChild(when);
    head.appendChild(av); head.appendChild(byline);
    var title = document.createElement('h3');
    title.className = 'community-card__title';
    title.textContent = p.title;
    var body = document.createElement('div');
    body.className = 'community-card__body rte';
    body.innerHTML = p.body_html; // built and escaped by the worker
    art.appendChild(head); art.appendChild(title); art.appendChild(body);
    if (p.previews && p.previews.length) {
      var grid = document.createElement('div');
      grid.className = 'community-card__preview-grid';
      p.previews.forEach(function (u) {
        var im = document.createElement('img');
        im.src = u; im.alt = '';
        grid.appendChild(im);
      });
      art.appendChild(grid);
    } else if (p.media_count) {
      var mc = document.createElement('p');
      mc.className = 'community-card__pending-note';
      mc.textContent = p.media_count + (p.media_count === 1 ? ' attachment' : ' attachments') + ' included, visible after approval.';
      art.appendChild(mc);
    }
    if (pending) {
      art.setAttribute('data-space-id', p.space_id || '');
      byline.appendChild(pendingBadge());
      var delPost = document.createElement('button');
      delPost.type = 'button';
      delPost.className = 'community-card__delete';
      delPost.setAttribute('data-delete-post', '');
      delPost.textContent = 'Delete';
      head.appendChild(delPost);
      art.appendChild(pendingNoteEl());
    }
    return art;
  }

  function pendingRemove(kind, id) {
    pendingSave(pendingLoad().filter(function (e) {
      return !(e.kind === kind && String(e.data.id) === String(id));
    }));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-composer]');
    if (!form) return;
    e.preventDefault();

    var titleInput = form.querySelector('input[name="title"]');
    var ta = form.querySelector('textarea[name="body"]');
    var select = form.querySelector('select[name="space_id"]');
    var nameWrap = form.querySelector('[data-name-wrap]');
    var nameInput = nameWrap.querySelector('input');
    var status = form.querySelector('[data-status]');
    var btn = form.querySelector('button[type="submit"]');

    var title = (titleInput.value || '').trim();
    var body = (ta.value || '').trim();
    var spaceId = form.getAttribute('data-space-id') || (select ? select.value : '');
    var topicIds = [];
    var fixedTopic = form.getAttribute('data-topic-id');
    if (fixedTopic) topicIds.push(fixedTopic);
    form.querySelectorAll('[data-topic-group]:not([hidden]) input:checked').forEach(function (cb) {
      topicIds.push(cb.value);
    });

    if (!title) { status.textContent = 'Give your post a title.'; titleInput.focus(); return; }
    if (!body) { status.textContent = 'Write something first.'; ta.focus(); return; }
    if (!spaceId) { status.textContent = 'Choose a category.'; if (select) select.focus(); return; }
    if (pickedMedia.some(function (m) { return m.status === 'uploading'; })) {
      status.textContent = 'One moment, your media is still uploading.'; return;
    }
    if (pickedMedia.some(function (m) { return m.status === 'error'; })) {
      status.textContent = 'Remove the failed file (the ×) before posting.'; return;
    }
    var mediaPayload = pickedMedia.filter(function (m) { return m.status === 'done'; })
      .map(function (m) { return { signed_id: m.signed_id, kind: m.kind, filename: m.filename, content_type: m.content_type }; });
    var mediaPreviews = pickedMedia.filter(function (m) { return m.kind === 'image' && m.previewUrl; })
      .map(function (m) { return m.previewUrl; });

    btn.disabled = true;
    status.textContent = 'Posting…';

    var chain = Promise.resolve({ ok: true });
    if (!nameWrap.hidden) {
      var name = (nameInput.value || '').trim();
      if (name.length < 2) { status.textContent = 'Please add your name.'; btn.disabled = false; nameInput.focus(); return; }
      chain = postJSON('/name', { name: name });
    }

    chain.then(function (n) {
      if (n && n.error) throw new Error(n.error);
      return postJSON('/posts', { title: title, body: body, space_id: spaceId, topic_ids: topicIds, media: mediaPayload });
    }).then(function (res) {
      if (res.needs_name) {
        nameWrap.hidden = false;
        status.textContent = 'Add your name, then post again.';
        nameInput.focus();
        btn.disabled = false;
        return;
      }
      if (res.error) throw new Error(res.error);

      res.post.media_count = mediaPayload.length;
      res.post.previews = mediaPreviews; // session-only, not saved
      var list = document.querySelector('[data-feed-list]');
      var empty = document.querySelector('[data-empty]');
      if (empty) empty.hidden = true;
      if (list) list.insertBefore(renderPost(res.post, true), list.firstChild);
      var stored = {};
      for (var k in res.post) { if (k !== 'previews') stored[k] = res.post[k]; }
      pendingAdd({ kind: 'post', author_key: me && me.author_key, data: stored });
      pickedMedia = [];
      renderMediaList();

      titleInput.value = '';
      ta.value = '';
      nameWrap.hidden = true;
      form.querySelectorAll('[data-topic-group] input:checked').forEach(function (cb) { cb.checked = false; });
      var modal = form.closest('[data-composer-modal]');
      if (modal) { modal.hidden = true; unlockPageScroll(); }
      btn.disabled = false;
      status.textContent = '';
    }).catch(function (err) {
      status.textContent = err.message || 'Something went wrong. Please try again.';
      btn.disabled = false;
    });
  });

  // ---- Likes ----------------------------------------------------------------
  var liked = {};
  try { liked = JSON.parse(localStorage.getItem('ix1-community-likes') || '{}'); } catch (e) { liked = {}; }
  function saveLiked() {
    try { localStorage.setItem('ix1-community-likes', JSON.stringify(liked)); } catch (e) { /* fine */ }
  }
  function paintLikes() {
    document.querySelectorAll('.community-card').forEach(function (card) {
      var id = card.getAttribute('data-post-id');
      var btn = card.querySelector('[data-like]');
      if (btn && liked[id]) { btn.classList.add('is-liked'); btn.setAttribute('aria-pressed', 'true'); }
    });
  }
  paintLikes();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-like]');
    if (!btn) return;
    if (!me || !me.logged_in) {
      var root = document.querySelector('.community-feed');
      var login = root && root.getAttribute('data-login-url');
      if (login) window.location.href = login;
      return;
    }
    var card = btn.closest('.community-card');
    var postId = card.getAttribute('data-post-id');
    var count = card.querySelector('[data-like-count]');
    var isLiked = btn.classList.contains('is-liked');

    btn.disabled = true;
    postJSON('/likes', { post_id: postId, action: isLiked ? 'unlike' : 'like' })
      .then(function (res) {
        if (res.error) throw new Error(res.error);
        if (isLiked) {
          btn.classList.remove('is-liked'); btn.setAttribute('aria-pressed', 'false');
          delete liked[postId];
          if (count) count.textContent = String(Math.max(0, (parseInt(count.textContent, 10) || 0) - 1));
        } else {
          btn.classList.add('is-liked'); btn.setAttribute('aria-pressed', 'true');
          liked[postId] = 1;
          if (count && (!res.note)) count.textContent = String((parseInt(count.textContent, 10) || 0) + 1);
        }
        saveLiked();
        btn.disabled = false;
      })
      .catch(function () { btn.disabled = false; });
  });

  // ---- Media decoration: wrap images with a zoom badge ---------------------
  function decorateMedia() {
    document.querySelectorAll('.community-card__body img, .community-card__comment-body img').forEach(function (img) {
      if (img.closest('.community-media-wrap')) return;
      var wrap = document.createElement('span');
      wrap.className = 'community-media-wrap';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
      var zoom = document.createElement('span');
      zoom.className = 'community-media-wrap__zoom';
      zoom.setAttribute('aria-hidden', 'true');
      zoom.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M11 8v6M8 11h6"/></svg>';
      wrap.appendChild(zoom);
    });
  }
  decorateMedia();

  // ---- Lightbox: click an image in a post/comment to view it full size -----
  function closeLightbox() {
    var lb = document.querySelector('.community-lightbox');
    if (lb) lb.remove();
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.community-card__body img, .community-card__comment-body img');
    if (!img) return;
    e.preventDefault();
    var lb = document.createElement('div');
    lb.className = 'community-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'Image preview');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'community-lightbox__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    var full = document.createElement('img');
    full.src = img.src;
    full.alt = img.alt || '';
    lb.appendChild(full);
    lb.appendChild(close);
    lb.addEventListener('click', closeLightbox); // click anywhere closes
    document.body.appendChild(lb);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  // ---- Delete your own pending post ----------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-delete-post]');
    if (!btn) return;
    var card = btn.closest('.community-card');
    if (!card) return;
    if (!window.confirm('Delete this post?')) return;

    btn.disabled = true;
    btn.textContent = 'Deleting…';
    postJSON('/posts/delete', {
      post_id: card.getAttribute('data-post-id'),
      space_id: card.getAttribute('data-space-id')
    }).then(function (res) {
      if (res.error) throw new Error(res.error);
      pendingRemove('post', card.getAttribute('data-post-id'));
      card.remove();
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Delete';
      window.alert(err.message || 'Could not delete. Please try again.');
    });
  });

  // ---- Delete your own comment --------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-delete]');
    if (!btn) return;
    var comment = btn.closest('[data-comment-id]');
    var card = btn.closest('.community-card');
    if (!comment || !card) return;
    if (!window.confirm('Delete this comment?')) return;

    btn.disabled = true;
    btn.textContent = 'Deleting…';
    postJSON('/comments/delete', {
      post_id: card.getAttribute('data-post-id'),
      comment_id: comment.getAttribute('data-comment-id')
    }).then(function (res) {
      if (res.error) throw new Error(res.error);
      var wasPending = comment.hasAttribute('data-pending');
      var replies = comment.querySelectorAll('.community-card__comment--reply').length;
      pendingRemove('comment', comment.getAttribute('data-comment-id'));
      comment.remove();
      if (!wasPending) bumpCount(card, -(1 + replies));
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Delete';
      window.alert(err.message || 'Could not delete. Please try again.');
    });
  });
})();
